let baseURL = '';
if (process.env.NODE_ENV === 'development') {
  //测试环境境
  baseURL = 'https://gymoo-project-api.yhbit.cn/v1';
} else {
  //正式环境
  baseURL = 'https://gymoo-project-api.yhbit.cn/v1';
}
export default baseURL;
